import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getConsent,
  grantAnalyticsConsent,
  revokeAnalyticsConsent,
  type ConsentState,
} from '../../lib/analytics'

/**
 * Widerruf und nachtraegliche Zustimmung zur Reichweitenmessung.
 *
 * Eine Einwilligung, die sich nicht genauso leicht zurueckziehen laesst, wie
 * sie erteilt wurde, ist keine wirksame Einwilligung — deshalb gehoert dieser
 * Schalter neben das Banner. Der Widerruf loescht zusaetzlich die gesetzten
 * _ga-Cookies; das bereits geladene Skript verschwindet erst beim naechsten
 * Seitenaufbau, worauf der Hinweistext eingeht.
 */
export function AnalyticsConsentSection() {
  const { t } = useTranslation('legal')
  const [consent, setConsent] = useState<ConsentState>(() => getConsent())

  return (
    <div className="card" data-testid="analytics-consent-section">
      <div className="card-header">
        <h3>{t('consent.settingsTitle', 'Reichweitenmessung')}</h3>
      </div>
      <div className="card-body">
        <p className="muted" style={{ marginTop: 0 }}>
          {consent === 'granted'
            ? t('consent.settingsGranted', 'Du hast der Messung zugestimmt.')
            : t('consent.settingsDenied', 'Die Messung ist abgeschaltet.')}
        </p>
        {consent === 'granted' ? (
          <button
            type="button"
            className="btn"
            onClick={() => {
              revokeAnalyticsConsent()
              setConsent('denied')
            }}
          >
            {t('consent.revoke', 'Zustimmung widerrufen')}
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              grantAnalyticsConsent()
              setConsent('granted')
            }}
          >
            {t('consent.grantFromSettings', 'Messung erlauben')}
          </button>
        )}
      </div>
    </div>
  )
}
